import {
  Cancel,
  Layers,
  PriceCheck,
  RepeatOneTwoTone,
  ViewInAr,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BtnSub,
  BtnSubscribed,
  PlanCard,
  PriceTitle,
  SubTitle,
  Text,
} from "./styles";
import { Toast } from "../../../components/components/Toast";
import Loader from "../../../components/components/Loader";

function ProCard({ onSelect, billingPeriod, handleBillingPeriodChange }) {
  console.log("billingPeriod:", billingPeriod);
  // const { user } = useSelector((state) => state.user);
  // const cancelSubscription = user?.cancelSubscription;
  const [modal, setModal] = useState(false);
  const toggleCancel = () => setModal((prev) => !prev);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();



  return (
    <>
      <PlanCard
        spacing={1.6}
        sx={{
          pb: "10px",
          justifyContent: "space-between",
        }}
      >
        <Stack spacing={1}>
          {/* Plan Details */}
          <Stack spacing={1}>
            <SubTitle>
              <Layers sx={{ marginRight: "4px" }} />
              Custom
            </SubTitle>
            <Stack alignItems="center" direction="row" justifyContent="center">
              <PriceTitle
                sx={{
                  fontFamily: "sans-serif !important",
                  fontSize: "2.25rem",
                }}
              >
                Rs. /-
              </PriceTitle>
              {/* <PriceTitle
                sx={{
                  ml: 2,
                  textDecoration: "line-through",
                  color: "#A2B0B7",
                  fontFamily: "sans-serif !important",
                  fontSize: "2.2rem",
                }}
              >
                $400
              </PriceTitle> */}
            </Stack>
            {/* <PriceTitle sx={{ color: "#A2B0B7", fontSize: "15px" }}>
              Billed {billingPeriod === "yearly" ? "Yearly" : "Monthly"}
            </PriceTitle> */}
     
     
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <PriceTitle sx={{ color: "#A2B0B7", fontSize: "15px" }}>
              /- activation
              </PriceTitle>
              {/* <Box
                sx={{
                  backgroundColor: "#1DB45A",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "5px",
                  marginInline: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Text
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Save 25%
                </Text>
              </Box> */}
            </Box>
          </Stack>
  
          {/* Billing Toggle */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Stack direction={"column"}>
          <PriceTitle sx={{ color: "#4EAF51", fontSize: "15px" }}>
          Tailored to your unique needs! 
              </PriceTitle>
              <PriceTitle sx={{ color: "#4EAF51", fontSize: "15px" }}>
              Contact us today to discuss 
              </PriceTitle>
              <PriceTitle sx={{ color: "#4EAF51", fontSize: "15px" }}>
              custom package pricing and
              </PriceTitle>
              <PriceTitle sx={{ color: "#4EAF51", fontSize: "15px" }}>
              specific feature limitations 
              </PriceTitle>
              <PriceTitle sx={{ color: "#4EAF51", fontSize: "15px" }}>
              that work best for you.
              </PriceTitle>
              </Stack>
          </Box>
        </Stack>
  


      </PlanCard>
    </>
  );
  
}

export default ProCard;
